import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, assetUrl } from '../api/index.js';
import { useLocale } from '../contexts/LocaleContext.jsx';

export default function Messages() {
  const navigate = useNavigate();
  const { t } = useLocale();
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.messages
      .conversations()
      .then((d) => setConversations(d.conversations ?? []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="w-8 h-8 border-4 border-brand-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-xl font-bold text-gray-900 mb-6">{t('messages')}</h1>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-4 py-3 mb-6">
          {error}
        </div>
      )}

      {conversations.length === 0 ? (
        <div className="card p-12 text-center text-gray-400">
          <div className="text-5xl mb-3">💬</div>
          <p className="font-medium">{t('noConversations')}</p>
          <p className="text-sm mt-1">{t('findAndDm')}</p>
          <Link to="/caddies" className="btn-primary mt-4 inline-flex">{t('findCaddie')}</Link>
        </div>
      ) : (
        <div className="card divide-y divide-gray-100">
          {conversations.map((c) => (
            <button
              key={c.other_id}
              onClick={() => navigate(`/messages/${c.other_id}`)}
              className="w-full flex items-center gap-3 px-4 py-4 hover:bg-gray-50 transition-colors text-left"
            >
              {c.avatar_url ? (
                <img src={assetUrl(c.avatar_url)} alt={c.display_name} className="w-11 h-11 rounded-full object-cover shrink-0" />
              ) : (
                <div className="w-11 h-11 rounded-full bg-brand-100 flex items-center justify-center text-brand-700 font-bold shrink-0">
                  {c.display_name?.[0]?.toUpperCase()}
                </div>
              )}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="font-semibold text-gray-900 text-sm">{c.display_name}</p>
                  {c.unread_count > 0 && (
                    <span className="rounded-full bg-brand-700 px-2 py-0.5 text-[10px] font-bold text-white">
                      {c.unread_count}
                    </span>
                  )}
                </div>
                <p className="text-sm text-gray-500 truncate">{c.last_message}</p>
              </div>
              <p className="text-xs text-gray-400 shrink-0">
                {c.last_at ? new Date(c.last_at).toLocaleDateString() : ''}
              </p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
